<template lang="pug">
.option-target-family-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません

    // セル：利用者グループ
    template(#cell(groupName)="row")
      span {{ row.item.groupName }}
    // セル：利用者
    template(#cell(residentName)="row")
      span {{ row.item.name }}（{{ row.item.room }}）
    // セル：家族ユーザー
    template(#cell(familyName)="row")
      span {{ row.item.familyName }}（{{ row.item.familyRelation }}）
    // セル：同意の返信日時
    template(#cell(datetime)="row")
      span(v-if="row.item.datetime != null") {{ convertDateText(row.item.datetime) }}
    // セル：返信時の連絡事項
    template(#cell(message)="row")
      span {{ row.item.message }}
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { SenderType } from "@/commons/services/Families";

/**
 * ### 文書送付、確認・同意ユーザー一覧テーブル
 */
@Component({})
export default class OptionTargetFamilyTable extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<OptionTargetFamilyTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<OptionTargetFamilyTableField>;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;

  get _value(): Array<OptionTargetFamilyTableItem> {
    return this.value;
  }

  public convertDateText(datetime: number): string {
    const date: string = this.$dateUtil.convertNumberToString(datetime, "yyyy年mm月dd日 hh:MM");
    return date;
  }
}

/** テーブルの列名の情報 */
export interface OptionTargetFamilyTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface OptionTargetFamilyTableItem {
  /** 利用者ソートキー */
  residentsSortKey: string;
  /** 利用者グループID */
  groupId: number;
  /** 利用者グループ名 */
  groupName: string;
  /** 利用者ID */
  id: number;
  /** 利用者名 */
  name: string;
  /** 部屋ID */
  roomId: number;
  /** 部屋名 */
  room: string;
  /** 送信種別 */
  senderType: SenderType;
  /** 家族ID */
  familyId: number;
  /** 家族名 */
  familyName: string;
  /** 家族続柄 */
  familyRelation: string;
  /** 家族役割 */
  familyPosition: string | null;
  /** 家族電話番号 */
  familyTel: string;
  /** 家族LINEID */
  familyLineId: string | null;
  /** 家族メールアドレス */
  familyMailaddress: string | null;
  /** 返信日時 */
  datetime: number | null;
  /** 返信内容 */
  message: string;
  /** 保険者番号 */
  insuredNumber: string | null;
  /** 介護保険被保険者番号 */
  careInsuranceInsuredNumber: string | null;
  /** 格納元情報 */
  source: any;

  /** 再送対象かどうか */
  isTarget: boolean;
  /** 再送確認モーダルのkey */
  key: string;
  /** 再送確認モーダルの表示名 */
  displayName: string;
}
</script>
